module.exports = __webpack_public_path__ + "img/HUD Diagram.63e0d4eb.png";